import "./styles/main.css";
import * as echarts from "echarts";
import { startMockWorker } from "@/mocks/browser";
import { ensureAppStore, resetAppStore } from "@/state/app-store";
import { bootstrap } from "@/app/app";
import { sessionApi } from "@/api/session";
import { clearAuthState, getAuthUserId, setAuthState } from "@/state/auth";
import { renderLoginPage } from "@/pages/login";

(window as unknown as { echarts: typeof echarts }).echarts = echarts;

function showLoginShell() {
  const app = document.getElementById("app");
  const loginRoot = document.getElementById("login-root");
  if (app) app.classList.add("hidden");
  if (loginRoot) {
    loginRoot.classList.remove("hidden");
    renderLoginPage(loginRoot, async () => {
      await startAppAfterLogin();
    });
  }
}

function showAppShell() {
  const app = document.getElementById("app");
  const loginRoot = document.getElementById("login-root");
  if (loginRoot) {
    loginRoot.classList.add("hidden");
    loginRoot.innerHTML = "";
  }
  if (app) app.classList.remove("hidden");
}

async function ensureAuthenticated(): Promise<boolean> {
  try {
    const verified = await sessionApi.verify();
    if (verified.valid && verified.user_id) {
      setAuthState(verified.user_id, true);
      return true;
    }
  } catch {
    // fall through
  }
  // MSW / soft: accept local auth marker if verify is false but we still have userId
  // (verify is authoritative when backend sets cookies).
  if (getAuthUserId() && String(import.meta.env.VITE_USE_MSW ?? "true") === "true") {
    try {
      await sessionApi.get();
      return true;
    } catch {
      clearAuthState();
    }
  }
  return false;
}

async function startAppAfterLogin() {
  showAppShell();
  resetAppStore();
  await ensureAppStore();
  bootstrap();
}

async function main() {
  try {
    await startMockWorker();
  } catch (err) {
    console.warn("[msw] worker start failed; fetch may hit real network or fail until backend is available", err);
  }

  const ok = await ensureAuthenticated();
  if (!ok) {
    showLoginShell();
    return;
  }

  await startAppAfterLogin();
}

void main();

declare global {
  interface Window {
    logoutEasyShare?: () => Promise<void>;
  }
}

window.logoutEasyShare = async () => {
  await sessionApi.logout();
  resetAppStore();
  location.hash = "#/login";
  location.reload();
};
